import React from 'react';

const Explore: React.FC = () => {
  return (
    <div className="w-full max-w-2xl mx-auto px-2 py-4 flex flex-col gap-6">
      <h2 className="text-2xl font-bold text-gray-700 mb-2">Explore</h2>
      <div className="grid grid-cols-1 gap-4">
        <div className="bg-white rounded-xl shadow p-6 flex flex-col gap-2">
          <div className="text-lg font-semibold text-gray-800">Guided Journals</div>
          <div className="text-gray-500">Try a new guided journal to deepen your self-reflection.</div>
          <button className="mt-2 px-4 py-2 bg-rose-500 text-white rounded-full font-semibold text-sm w-max">Start Journal</button>
        </div>
        <div className="bg-white rounded-xl shadow p-6 flex flex-col gap-2">
          <div className="text-lg font-semibold text-gray-800">Personalized Prompts</div>
          <div className="text-gray-500">Get a prompt tailored to your current mood and goals.</div>
          <button className="mt-2 px-4 py-2 bg-rose-500 text-white rounded-full font-semibold text-sm w-max">Get Prompt</button>
        </div>
      </div>
    </div>
  );
};

export default Explore; 